<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from "../themeConfig";

export default {
  data() {
    return {
      isTabClosed: false,
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    isTabClosed(newValue) {
      if (newValue) {
        console.log("User Left the page or closed the tab");
      }
    },
  },

  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    async handleBeforeUnload(event) {
      console.log("Hello Anish");
      this.isTabClosed = true;
      await this.$store.commit("RESET_STATE");
      // event.preventDefault();
      // return (event.returnValue = "Are you sure you want to?");
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  async mounted() {
    window.addEventListener("resize", this.handleWindowResize);
    this.toggleClassInBody(themeConfig.theme);
    this.handleWindowResize();
    await this.$store.dispatch("modules/getModules");

    if (process.env.VUE_APP_COMMUNITY_NAME === "nhrdn") {
      await this.$store.dispatch("user/getVersion", {
        projectName: "brained-admin-vue",
      });
    } else {
      await this.$store.dispatch("user/getVersion", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
    }

    // window.addEventListener("beforeunload", this.handleBeforeUnload);

    //    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    // const response = await this.$apollo.query({
    //   query: gql`
    //     query {
    //       allUsers {
    //         id
    //         email
    //       }
    //     }
    //   `,
    // });
    // console.log(response.data.allUsers);
  },
  // async created() {
  //   // jwt
  //   jwt.init();

  //   window.addEventListener("scroll", this.handleScroll);

  //   // Auth0
  //   try {
  //     await this.$auth.renewTokens();
  //   } catch (e) {
  //     console.error(e);
  //   }
  // },

  beforeDestroy() {
    // window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
